import './modal-body.css';
import { jsx } from 'react/jsx-runtime';
import styles from './modal-body.module.scss.js';

/**
 * @component Modal
 * @package Modals
 */
const ModalBody = ({ children, 'data-testid': testId = 'modal-body', colorMode = 'light', title, noCloseButton, }) => {
    const modalBodyStyles = [styles.modalBody];
    if (colorMode === 'dark') {
        modalBodyStyles.push(styles.dark);
    }
    if ((!title || !(title === null || title === void 0 ? void 0 : title.children)) && noCloseButton) {
        modalBodyStyles.push(styles.noCloseButton);
    }
    if ((!title || !(title === null || title === void 0 ? void 0 : title.children)) && !noCloseButton) {
        modalBodyStyles.push(styles.noTitle);
    }
    return (jsx("div", { className: modalBodyStyles.join(' '), "data-testid": testId, children: children }));
};

export { ModalBody as default };
